import Input from 'components/Input';
import styled from 'styled-components';

export const InputDocument = styled(Input).attrs({
  id: "documentNumberSimple",
  stateName: "documentNumberSimple",
  name: "CPF/CNPJ",
  className: "w-100",
  type: "text",
  required: true,
  placeholder: "CPF/CNPJ",
  maxLength: 18
})``;

export const InputCustomer = styled(Input).attrs({
  id: "customerNameSimple",
  stateName: "customerNameSimple",
  name: "Cliente",
  className: "w-100",
  type: "text",
  required: true,
  placeholder: "Cliente",
  minLength: 3
})`
  width: 320px;

  @media screen and (max-width: 869px) {
    width: 100%;
  }
`;
